// The car size words: the ONLY copy of them. The size buttons on Book & pay,
// the ask-at-Pay panel under the pay buttons and the home page's car size
// note all read them
// from here, so they cannot drift apart again.
//
// They did: e66a7b97 (10 Oct 2026) moved saloons to small on the form's
// buttons, but the ask-at-Pay panel kept "Large: Saloon, SUV or 4x4" and
// "Small: Hatchback, estate", and a payer picked Large from that panel
// (order 51815, gowashmycar-research/address-leavers-2026-10-11.md §3).
//
// No em dashes: this is customer copy.
export const CAR_SIZES = [
  { value: 'small', title: 'Small to medium', desc: 'Hatchbacks, saloons and estates, e.g. Golf, A4, A8, 3 Series' },
  { value: 'large', title: 'Large', desc: 'Big SUVs, 4x4s, 7 seaters and vans, e.g. Range Rover, X5, Q7, XC90.' }
]

// The size buttons with the live surcharge on the large one's label
// ("Large +£20", 19 Oct 2026: on the label, not at the end of the
// description, so the total never surprises); no amount when the price has
// not loaded.
export const carSizeOptions = largeCarPrice => CAR_SIZES.map(size => (
  size.value === 'large' && largeCarPrice ? { ...size, title: `${size.title} +${largeCarPrice}` } : size
))

// What counts as large, in a sentence ("big SUVs, 4x4s, 7 seaters and vans").
export const LARGE_CAR_WORDS = 'big SUVs, 4x4s, 7 seaters and vans'
